class viewCartSummaryController {
    /* @ngInject */
    constructor() {
    }
}

export default viewCartSummaryController;


// WEBPACK FOOTER //
// ./src/app/components/view-cart/view-cart-summary/view-cart-summary.controller.js